module.exports = __webpack_public_path__ + "static/img/thumbnail.2ada85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/200204/thumbnail.jpg
// module id = YjbE
// module chunks = 1